import useOnLoad from '../../hooks/queries/useOnLoad';
import { IncludedSize } from '../../../types/isomorphic';

const useAvailableSizes = (): IncludedSize[] => {
  const { response: { config: { availableSizes } = {} } = {} } = useOnLoad();
  return (availableSizes as IncludedSize[] | undefined) ?? [];
};

export default useAvailableSizes;
